const RISK_CATEGORIES = [
  {
    id: 'heat-wave',
    helpText: 'The risk of heat waves, measured as the amount of days in heat wave conditions, is estimated to be <strong>{{riskValue}}</strong>.',
  },
  {
    id: 'fire',
    helpText: 'The risk of wildfire, measured as the amount of days with fire weather, is <strong>{{riskValue}}</strong>.',
  },
  {
    id: 'extreme-precipitation',
    helpText: 'The risk of floods, measured as people expected to be affected by flooding per river basin, is <strong>{{riskValue}}</strong>.',
  },
  {
    id: 'extreme-wind',
    helpText: 'The risk of tropical cyclones, measured as the probability of extreme wind speeds above 18 m/s, is estimated to be <strong>{{riskValue}}</strong>.',
  },
  {
    id: 'dry-spell',
    helpText: 'The risk of dry spells, measured as the amount of consecutive dry days, is estimated to be <strong>{{riskValue}}</strong>.',
  },
];

export {
  RISK_CATEGORIES,
};